module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.4c48ff83.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Bold.woff2
// module id = 348
// module chunks = 3